import { createSelector } from 'reselect';

import { selectViolationStateMap } from './selectViolationStateMap';

export const selectViolations = (id: string) =>
  createSelector([selectViolationStateMap], (violationStateMap) => violationStateMap[id]);
